import React from "react";
import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import ReactMarkdown from "react-markdown";
import ImageCarousel from "../utils/ImageCarousel";

import {
  eventText,
  eventImageWrapper,
  eventHeader,
  eventWrapper,
} from "../css/eventTemplate.module.css";

const Event = ({ data }) => {
  const {
    strapiEvent: { eventTitle, eventDescription, mainImage },
  } = data;

  return (
    <>
      <div className={eventWrapper}>
        <div className={eventHeader}>
          <h1>{eventTitle}</h1>
        </div>

        <div className={eventImageWrapper}>
          <GatsbyImage
            image={mainImage.childImageSharp.gatsbyImageData}
            alt={eventTitle}
            imgStyle={{ objectFit: "cover" }}
            style={{ height: "100%", maxHeight: "539px" }}
          />
        </div>
        <div className={eventText}>
          <ReactMarkdown source={eventDescription} />
        </div>
      </div>
    </>
  );
};

export default Event;

export const query = graphql`
  query event($slug: String!) {
    strapiEvent(slug: { eq: $slug }) {
      id
      slug
      eventTitle
      eventDescription
      mainImage {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
        }
      }
    }
  }
`;
